import axios, { AxiosInstance } from "axios";

const { CYBER_SOURCE_URL } = window.MLBBest.envVariables || {};

const client: AxiosInstance = axios.create({ baseURL: CYBER_SOURCE_URL });

export default client;
